module.exports = __webpack_public_path__ + "img/enw.ee26372f.jpg";